export default "__VITE_ASSET__DHugQ6Qe__";